import { render, staticRenderFns } from "./RodoList.vue?vue&type=template&id=07c25b29"
import script from "./RodoList.vue?vue&type=script&lang=js"
export * from "./RodoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports